export default {
    data() {
        return {
            domesticCharts: null,
            eCharts: null,
            tCharts: null,
            apiCharts: null,
            iciCharts: null,
        };
    },
    methods: {
        getDomesticCharts() {
            let that = this;
            if (that.domesticCharts === null) {
                that.domesticCharts = that.$echarts.init(document.getElementById("domestic-echarts"));
            }
            var option = {
                title: {
                    text: '',
                    subtext: '数据来源于实际情况',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['CCI5500', 'CCI5000', 'CCI4500', '4500差值'],
                    top: '10%'
                },
                grid: {
                    top: '30%',
                    left: '3%',
                    right: '5%',
                    bottom: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: [
                        '2024/08/12', '2024/08/13', '2024/08/14', '2024/08/15', '2024/08/16',
                        '2024/08/19', '2024/08/20', '2024/08/21', '2024/08/22', '2024/08/23',
                        '2024/08/26', '2024/08/27', '2024/08/28', '2024/08/29', '2024/08/30',
                        '2024/09/02', '2024/09/03', '2024/09/04', '2024/09/05', '2024/09/06',
                        '2024/09/09', '2024/09/10', '2024/09/11', '2024/09/12', '2024/09/13',
                        '2024/09/14', '2024/09/15', '2024/09/16', '2024/09/17', '2024/09/18',
                        '2024/09/19', '2024/09/20', '2024/09/23', '2024/09/24', '2024/09/25',
                        '2024/09/26', '2024/09/27', '2024/09/29', '2024/09/30', '2024/10/08',
                        '2024/10/09', '2024/10/10', '2024/10/11', '2024/10/12', '2024/10/14',
                        '2024/10/15', '2024/10/16', '2024/10/17', '2024/10/18', '2024/10/21',
                        '2024/10/22', '2024/10/23', '2024/10/24', '2024/10/25', '2024/10/28',
                        '2024/10/29', '2024/10/30', '2024/10/31', '2024/11/01', '2024/11/04',
                        '2024/11/05', '2024/11/06', '2024/11/07', '2024/11/08', '2024/11/11',
                        '2024/11/12',
                    ]
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    }
                },
                series: [
                    {
                        name: 'CCI5500',
                        type: 'line',
                        data: [
                            798, 808, 826, 841, 865, 893, 918, 941, 945, 946, 947, 948, 973, 1010, 1038, 1061, 1093, 1126, 1129, 1111, 1070, 1056, 1057,
                            1059, 1065, 1064, 1043, 1018, 1000, 960, 950, 990, 1040, 1100, 1140, 1170, 1180, 1180, 1260, 1265, 1300, 1350, 1620, 1690,
                            1720, 1720, 1675, 1630, 1580, 1500, 1530, 1560, 1600, 1620, 1640, 1600, 1550, 1480, 1420, 1360, 1280, 1160, 1200, 1200, 1350
                        ]
                    },
                    {
                        name: 'CCI5000',
                        type: 'line',
                        data: [
                            694, 710, 721, 733, 766, 793, 817, 834, 835, 837, 844, 856, 871, 908, 926, 953, 979, 1007, 1009, 993, 970, 968, 967, 967, 966,
                            946, 924, 890, 840, 830, 880, 940, 980, 1025, 1050, 1050, 1135, 1140, 1200, 1240, 1450, 1510, 1550, 1550, 1520, 1460, 1400,
                            1290, 1300, 1340, 1370, 1400, 1450, 1400, 1370, 1300, 1250, 1180, 1110, 1020, 980, 950, 930, 930, 980, 1050, 1060, 1060, 1060
                        ]
                    },
                    {
                        name: 'CCI4500',
                        type: 'line',
                        data: [
                            532, 551, 566, 585, 614, 638, 675, 682, 693, 705, 712, 729, 751, 771, 799, 825, 858, 874, 879, 867, 848, 846, 845, 849, 849,
                            832, 813, 800, 740, 730, 775, 820, 860, 885, 925, 950, 975, 980, 995, 1050, 1260, 1330, 1380, 1360, 1330, 1300, 1250, 1140,
                            1150, 1180, 1220, 1240, 1280, 1300, 1260, 1240, 1220, 1210, 1220, 1220, 1220, 1220, 1150, 1085, 1050, 1065, 1075, 1070, 1060
                        ]
                    },
                    {
                        name: '4500差值',
                        type: 'line',
                        data: [
                            -166, -147, -132, -113, -84, -60, -22, -14, -2, 10, 16, 33, 56, 77, 85, 84, 90, 66, 38, 28, 9, 5, -52, -84, -81, -98, -116,
                            -126, -186, -195, -151, -106, -65, -41, -20, -41, -37, -51, -73, -87, 82, 97, 45, 25, -5, -44, -98, -167, -157, -97, -35, -15,
                            12, -30, -60, -115, -134, -114, -141, -203, -163, -144, -109, -118, -138, -154, -167, -151, -150, -162, -128, -119, -139, -138,
                            -125, -125, -123, -110, -122, -138, -125, -138, -143, -137, -134, -122, -138, -138, -148, -143, -137, -134
                        ]
                    }
                ]
            };


            that.domesticCharts.setOption(option);
        },
        getECharts() {
            let that = this;
            if (that.eCharts === null) {
                that.eCharts = that.$echarts.init(document.getElementById("e-echarts"));
            }
            var option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['沿海八省电厂库存', '内陆17省电厂库存', '北港库存']
                },
                grid: {
                    top: '20%',
                    left: '3%',
                    right: '5%',
                    bottom: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: ['2024/09/09', '2024/09/10', '2024/09/11', '2024/09/12', '2024/09/13', '2024/09/14', '2024/09/15', '2024/09/16', '2024/09/17', '2024/09/18', '2024/09/19', '2024/09/20', '2024/09/21', '2024/09/22', '2024/09/23', '2024/09/24', '2024/09/25', '2024/09/26', '2024/09/27', '2024/09/28', '2024/09/29', '2024/09/30', '2024/10/01', '2024/10/02', '2024/10/03', '2024/10/04', '2024/10/05', '2024/10/06', '2024/10/07', '2024/10/08', '2024/10/09', '2024/10/10', '2024/10/11', '2024/10/12', '2024/10/13', '2024/10/14', '2024/10/15', '2024/10/16', '2024/10/17', '2024/10/18', '2024/10/19', '2024/10/20', '2024/10/21', '2024/10/22', '2024/10/23', '2024/10/24', '2024/10/25', '2024/10/26', '2024/10/27', '2024/10/28', '2024/10/29', '2024/10/30', '2024/10/31', '2024/11/01', '2024/11/02', '2024/11/03', '2024/11/04', '2024/11/05', '2024/11/06', '2024/11/07', '2024/11/08', '2024/11/09', '2024/11/10', '2024/11/11', '2024/11/12', '2024/11/13', '2024/11/14', '2024/11/15', '2024/11/16', '2024/11/17', '2024/11/18', '2024/11/19', '2024/11/20', '2024/11/21', '2024/11/22']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '沿海八省电厂库存',
                        type: 'line',
                        data: [3437, 3420, 3423, 3410, 3401, 3378, 3368, 3376, 3358, 3361, 3352, 3359, 3355, 3342, 3339, 3354, 3349, 3360, 3379, 3394, 3405, 3395, 3438, 3463, 3479, 3484, 3477, 3461, 3475, 3495, 3490, 3485, 3488, 3485, 3479, 3487, 3524, 3538, 3549, 3549, 3539, 3529, 3510, 3497, 3495, 3504, 3500, 3479, 3485, 3480, 3451, 3436, 3439, 3458, 3466, 3477, 3503, 3505, 3519, 3540, 3537, 3533, 3534, 3549, 3524, 3515, 3521, 3532, 3533, 3545, 3551, 3558, 3552, 3561, 3550]
                    },
                    {
                        name: '内陆17省电厂库存',
                        type: 'line',
                        data: [8309, 8265, 8252, 8240, 8231, 8237, 8254, 8244, 8237, 8230, 8273, 8288, 8357, 8440, 8491, 8511, 8533, 8551, 8612, 8661, 8720, 8739, 8781, 8884, 8994, 9055, 9118, 9125, 9079, 9174, 9216, 9223, 9261, 9290, 9315, 9363, 9373, 9393, 9375, 9446, 9459, 9522, 9527, 9535, 9558, 9578, 9628, 9666, 9688, 9699, 9742, 9772, 9740, 9753, 9762, 9793, 9814, 9846, 9861, 9899, 9937, 9972, 10003, 10032, 10048, 10059, 10064, 10102, 10071, 10046, 10027, 10033, 10038, 10035, 10071]
                    },
                    {
                        name: '北港库存',
                        type: 'line',
                        data: [2154, 2144, 2151, 2191, 2145, 2153, 2132, 2130, 2118, 2118, 2108, 2131, 2187, 2190, 2190, 2227, 2282, 2305, 2286, 2254, 2226, 2202, 2190, 2186, 2163, 2189, 2193, 2188, 2168, 2191, 2201, 2221, 2227, 2219, 2240, 2254, 2269, 2278, 2254, 2223, 2271, 2276, 2302, 2318, 2316, 2326, 2322, 2327, 2344, 2344, 2367, 2381, 2362, 2355, 2366, 2361, 2382, 2410, 2434, 2470, 2501, 2519, 2518, 2543, 2552, 2569, 2609, 2636, 2639, 2645, 2666, 2689, 2714, 2709, 2703]
                    }
                ]
            };


            that.eCharts.setOption(option);
        },

        getTCharts() {
            let that = this;
            if (that.tCharts === null) {
                that.tCharts = that.$echarts.init(document.getElementById("t-echarts"));
            }
            var option = {
                title: {
                    subtext: '数据来源于实际情况',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    },
                    // 动态调整 tooltip 的位置
                    position: function (point, params, dom, rect, size) {
                        // 保证 tooltip 不会超出屏幕范围
                        var padding = 10; // 适当的内边距
                        var x = point[0] + padding;
                        var y = point[1] - 50; // 提示框上移一点避免遮挡
                        var maxX = size.viewSize[0] - padding; // 屏幕最大宽度
                        var maxY = size.viewSize[1] - padding; // 屏幕最大高度

                        // 如果 tooltip 超出右边界，调整它的 x 坐标
                        if (x + dom.offsetWidth > maxX) {
                            x = maxX - dom.offsetWidth;
                        }
                        // 如果 tooltip 超出下边界，调整它的 y 坐标
                        if (y + dom.offsetHeight > maxY) {
                            y = maxY - dom.offsetHeight;
                        }

                        return [x, y];
                    },
                    formatter: function (params) {
                        let result = params[0].name + '<br>';
                        params.forEach(function (item) {
                            result += item.seriesName + ': ' + (that.$verify.checkIfNull(item.value) ? '无' : (item.value + '$')) + '<br>';
                        });
                        return result;
                    },
                    confine: true  // 强制 tooltip 在图表内显示
                },
                grid: {
                    top: '20%',
                    left: '3%',
                    right: '5%',
                    bottom: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: [
                        '2024/09/02', '2024/09/03', '2024/09/04', '2024/09/05', '2024/09/06', '2024/09/09',
                        '2024/09/10', '2024/09/11', '2024/09/12', '2024/09/13', '2024/09/18', '2024/09/19',
                        '2024/09/20', '2024/09/23', '2024/09/24', '2024/09/25', '2024/09/26', '2024/09/27',
                        '2024/09/30', '2024/10/08', '2024/10/09', '2024/10/10', '2024/10/11', '2024/10/14',
                        '2024/10/15', '2024/10/16', '2024/10/17', '2024/10/18', '2024/10/21', '2024/10/22',
                        '2024/10/23', '2024/10/24', '2024/10/25', '2024/10/28', '2024/10/29', '2024/10/30',
                        '2024/10/31', '2024/11/01', '2024/11/04', '2024/11/05', '2024/11/06', '2024/11/07',
                        '2024/11/08', '2024/11/11', '2024/11/18', '2024/11/19', '2024/11/20'
                    ]
                },
                yAxis: {
                    type: 'value',
                    name: '(万吨)',
                    min: 0
                },
                series: [
                    {
                        name: '印尼萨马林达-中国广州-7万吨船',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: [
                            7.32, 7.30, 7.33, 7.36, 7.39, null, null, 7.42, 7.45, 7.48, 7.49, null, null,
                            null, null, 7.50, 7.51, 7.53, 7.56, 7.65, 7.70, 7.75, 7.69, null, null, 7.66,
                            null, null, 7.76, 7.79, 7.73, 7.67, null, null, 7.61, 7.51, 7.40, 7.29, 7.24,
                            7.19, 7.18, 7.16, 7.17, 7.17, 7.16, 7.15, 7.13, 7.12, 7.11, 7.09, 7.07, 7.05,
                            7.07, 7.08, 12.59, 12.56, 12.52
                        ]
                    },
                    {
                        name: '印尼塔巴尼奥-中国南通-5万吨船',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: [
                            13.41, 13.42, 13.45, 13.45, 13.45, null, null, 13.43, 13.43, 13.44, 13.47, null, null,
                            null, null, 13.50, 13.54, 13.63, 13.77, 13.89, 13.93, 13.91, 13.87, null, null, 13.84,
                            13.88, 13.89, 13.85, 13.79, null, null, 13.73, 13.67, 13.63, 13.57, 13.58, 13.53,
                            13.51, 13.49, 13.46, 13.44, 13.42, 13.38, 13.29, 13.25, 13.19, 13.16, 13.08, 13.04,
                            13.02, 13.00, 12.93, 19.11, 18.63, 18.48
                        ]
                    },
                    {
                        name: '澳大利亚纽卡斯尔-中国舟山-13万吨船',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: [
                            16.68, 17.00, 16.94, 16.76, 16.92, null, null, 17.06, 16.99, 16.87, 16.87, null, null,
                            null, null, 16.72, 16.86, 16.97, 16.95, 16.95, 16.95, 16.92, 16.91, null, null, 16.91,
                            16.24, 16.04, 15.36, 15.30, null, null, 15.39, 15.33, 15.01, 14.73, 14.60, null, 14.50,
                            14.14, 13.99, 13.93, 13.93, 13.89, 13.84, 13.84, 13.77, 13.76, 13.76, 13.91, 14.22,
                            14.27, 14.42, 14.60, 7.14, 7.12, 7.10
                        ]
                    },
                    {
                        name: '澳大利亚纽卡斯尔-南中国-7万吨船',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: [
                            null, null, 14.85, null, null, null, null, null, null, null, null, null, null, null, null,
                            null, null, null, null, 16.50, null, null, 15.80, null, null, null, null, null, 14.70,
                            14.50, null, null, null, 14.50
                        ]
                    }
                ]
            };


            that.tCharts.setOption(option);
        },
        getApiCharts() {
            let that = this;
            if (that.apiCharts === null) {
                that.apiCharts = that.$echarts.init(document.getElementById("api-echarts"));
            }
            let option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['API5', 'API8']
                },
                grid: {
                    top: '20%',
                    left: '5%',
                    right: '5%',
                    bottom: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: ['2024年03月22日', '2024年03月29日', '2024年04月05日', '2024年04月12日', '2024年04月19日', '2024年04月26日', '2024年05月03日', '2024年05月10日', '2024年05月17日', '2024年05月24日', '2024年05月31日', '2024年06月07日', '2024年06月14日', '2024年06月21日', '2024年06月28日', '2024年07月05日', '2024年07月12日', '2024年07月19日', '2024年07月26日', '2024年08月02日', '2024年08月09日', '2024年08月16日', '2024年08月23日', '2024年08月30日', '2024年09月06日', '2024年09月13日', '2024年09月20日', '2024年09月27日', '2024年10月04日', '2024年10月11日', '2024年10月18日', '2024年10月25日', '2024年11月01日', '2024年11月08日', '2024年11月15日', '2024年11月22日']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: 'API5',
                        type: 'line',
                        areaStyle: {},
                        data: [87.85, 87.37, 85.69, 85.32, 87.51, 87.52, 89.13, 90.73, 90.78, 92.16, 91.35, 88.27, 88.45, 87.97, 86.92, 87.72, 88.45, 87.73, 87.90, 87.83, 87.31, 86.78, 86.41, 86.85, 86.83, 86.95, 87.38, 88.68, 90.29, 90.97, 90.28, 89.64, 89.49, 89.42, 88.12, 87.60]
                    },
                    {
                        name: 'API8',
                        type: 'line',
                        areaStyle: {},
                        data: [104.74, 102.25, 100.09, 99.69, 100.81, 101.75, 102.59, 105.50, 105.75, 106.86, 106.08, 104.11, 102.80, 102.17, 101.55, 101.31, 101.75, 101.68, 101.77, 101.41, 101.03, 100.56, 99.94, 99.91, 100.45, 101.77, 102.55, 104.57, 104.40, 104.39, 104.00, 103.56, 103.31, 102.96, 102.41, 101.37]
                    }
                ]
            }

            that.apiCharts.setOption(option);
        },
        getIciCharts() {
            let that = this;
            if (that.iciCharts === null) {
                that.iciCharts = that.$echarts.init(document.getElementById("ici-echarts"));
            }
            let option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['ICI1', 'ICI2', 'ICI3', 'ICI4', 'ICI5']
                },
                grid: {
                    top: '20%',
                    left: '5%',
                    right: '5%',
                    bottom: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: ['2024/08/23', '2024/08/30', '2024/09/06', '2024/09/13', '2024/09/20', '2024/09/27', '2024/10/04', '2024/10/11', '2024/10/18', '2024/10/25', '2024/11/01', '2024/11/08', '2024/11/15', '2024/11/22']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: 'ICI1',
                        type: 'line',
                        smooth: true,
                        data: [128.33, 128.17, 129.53, 129.46, 127.58, 127.50, 128.47, 129.45, 130.32, 130.38, 130.98, 131.58, 131.64, 132.31]
                    },
                    {
                        name: 'ICI2',
                        type: 'line',
                        smooth: true,
                        data: [92.73, 92.42, 92.21, 92.42, 93.14, 93.19, 93.60, 93.51, 93.75, 93.80, 93.85, 93.93, 93.91, 93.85]
                    },
                    {
                        name: 'ICI3',
                        type: 'line',
                        smooth: true,
                        data: [72.10, 71.96, 71.80, 72.03, 72.51, 73.05, 73.09, 73.19, 73.25, 73.45, 73.25, 73.28, 73.40, 73.31]
                    },
                    {
                        name: 'ICI4',
                        type: 'line',
                        smooth: true,
                        data: [50.64, 50.08, 50.38, 50.91, 51.49, 51.75, 52.07, 52.34, 52.22, 52.31, 52.22, 52.32, 52.34, 52.19]
                    },
                    {
                        name: 'ICI5',
                        type: 'line',
                        smooth: true,
                        data: [31.36, 31.03, 31.03, 31.16, 31.35, 31.55, 31.91, 32.20, 32.14, 32.29, 32.28, 32.37, 32.43, 32.37]
                    }
                ]
            }

            that.iciCharts.setOption(option);
        },
    },

    created() {
        this.$nextTick(() => {
            this.getDomesticCharts();
            this.getECharts();
            this.getTCharts();
            this.getApiCharts();
            this.getIciCharts();
        });
    }
}
